import React from 'react'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { cn } from '@/lib/utils'
import { WalletConnectControl } from '@/wallet/WalletConnectControl'

interface WalletSessionPanelProps {
  className?: string
}

/** Bloque visual de sesión/wallet en el drawer móvil (< xl). Sin navegación a perfil. */
export function WalletSessionPanel({ className }: WalletSessionPanelProps) {
  const t = useTranslation()

  return (
    <div className={cn('mobile-app__drawer-block', className)}>
      <p className="mobile-app__drawer-section-label">{t.wallet.session}</p>
      <WalletConnectControl variant="drawer" />
    </div>
  )
}
